import { useAccountPreferences } from '~publish/contexts/AccountContext'
import type { LandingPage } from '~publish/contexts/AccountContext/graphqlEnums'

/**
 * Returns the user's preferred landing page.
 *
 * `'default'` is the wire-level sentinel meaning "client decides" — the caller
 * is responsible for resolving it to a concrete route.
 */
export const useDefaultLandingPage = (): LandingPage => {
  return useAccountPreferences()?.landingPage ?? 'default'
}
